export default "__VITE_ASSET__8081828c__"